import {
    EDIT_ADD_MODULE_MASTER_SUCCESS,
    EDIT_ADD_MODULE_MASTER_FAILED,
    RESET_EDIT_ADD_MODULE_MASTER,
    LOADING_RESET_EDIT_ADD_MODULE_MASTER,
    NETWORK_ERROR_RESET_EDIT_ADD_MODULE_MASTER
} from "../types/index";

const initialState = {
    isLoading: false,
    success: false,
    network: false,
    failed: false,
    data: {},
    message: "",
    networkError: ""
};

export default (state = initialState, action) => {
    switch (action.type) {
        case LOADING_RESET_EDIT_ADD_MODULE_MASTER:
            return {
                ...state,
                isLoading: true,
                success: false,
                failed: false,
                network: false,
                data: {},
                message: "",
                networkError: ""
            };
        case EDIT_ADD_MODULE_MASTER_FAILED:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: true,
                network: false,
                data: action.payload,
                message: "",
                networkError: ""
            };
        case EDIT_ADD_MODULE_MASTER_SUCCESS:
            return {
                ...state,
                isLoading: false,
                success: true,
                failed: false,
                network: false,
                data: action.payload,
                message: "",
                networkError: ""
            };
        case NETWORK_ERROR_RESET_EDIT_ADD_MODULE_MASTER:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: false,
                network: true,
                data: {},
                message: "",
                networkError: ""
            };
        case RESET_EDIT_ADD_MODULE_MASTER:
            return (state = initialState);
        default:
            return state;
    }
};
